import { createSlice } from "@reduxjs/toolkit";
import {
  getZone,
  AddZone,
  DeleteZone,
  getFloor,
  AddFloor,
  DeleteFloor,
  AddAsset,
  getAsset,
  RoomAndProperty,
  AddRoom,
  getFeeType,
  AddRoomSize,
  getFacilities,
  getUnit,
  getAssetType,
  getRoomAndProperty,
  // getRoomdetaillist,
  getAddFee,
  getNewAsset,
  addFeeDtails,
  getFeeDtails,
  getResultsAsset,
  editAsset,
  deleteRoom,
  editFeeDetails,
  editRoom,
  addMapSetup,
  getMapSetup,
  postImageMapSetup,
  getImageMapSetup,
  deleteMapSetup,
  editMapSetup,
  deleteImgMap,
  deleteAsset,
  editContractExpired,
  deleteFeeDetails,
} from "API/AssetAPI";

const initialState = {
  Zone: [],
  AddZone: [],
  DeleteZone: [],
  Floor: [],
  AddFloor: [],
  DeleteFloor: [],
  AddAsset: [],
  EditAsset: [],
  Assetdetail: [],
  ResultsAsset: [],
  RoomAndProperty: [],
  AddRoom: [],
  EditRoom: [],
  DeleteRoom: [],
  FeeType: [],
  RoomSize: [],
  Facilities: [],
  Unit: [],
  AssetTypeDetail: [],
  RoomAndPropertyList: [],
  Roomdetaillist: [],
  Fee: [],
  FeeDetails: [],
  NewAsset: [],
  AddFeeDetails: [],
  DeleteFeeDetails: [],
  EditFeeDetails: [],
  AddMap: [],
  Map: [],
  ImgMap: [],
  DeleteImgMap: [],
  ResultsMap: [],
  DeleteMap: [],
  EditMap: [],
  DeleteAsset: [],
  ContractExpired: [],
  loading: false,
};

export const AssetSlice = createSlice({
  name: "UserState",
  initialState,
  reducers: {
    updateGetZone: (state, action) => {
      state.Zone = action.payload;
    },
    updateAddZone: (state, action) => {
      state.AddZone = action.payload;
    },
    updateDeleteZone: (state, action) => {
      state.DeleteZone = action.payload;
    },
    updateGetFloor: (state, action) => {
      state.Floor = action.payload;
    },
    updateAddFloor: (state, action) => {
      state.AddFloor = action.payload;
    },
    updateDeleteFloor: (state, action) => {
      state.DeleteFloor = action.payload;
    },
    updateAddAsset: (state, action) => {
      state.AddAsset = action.payload;
    },
    updategetAsset: (state, action) => {
      state.Assetdetail = action.payload;
    },
    updateRoomAndProperty: (state, action) => {
      state.RoomAndProperty = action.payload;
    },
    updateAddRoom: (state, action) => {
      state.AddRoom = action.payload;
    },
    updategetFeeType: (state, action) => {
      state.FeeType = action.payload;
    },
    updateAddRoomSize: (state, action) => {
      state.RoomSize = action.payload;
    },
    updategetFacilities: (state, action) => {
      state.Facilities = action.payload;
    },
    updategetUnit: (state, action) => {
      state.Unit = action.payload;
    },
    updategetAssetType: (state, action) => {
      state.AssetTypeDetail = action.payload;
    },
    updategetRoomAndProperty: (state, action) => {
      state.RoomAndPropertyList = action.payload;
    },
    updategetRoomdetaillist: (state, action) => {
      state.Roomdetaillist = action.payload;
    },
    updategetAddFee: (state, action) => {
      state.Fee = action.payload;
    },
    updategetNewAsset: (state, action) => {
      state.NewAsset = action.payload;
    },
    updateAddFeeDtails: (state, action) => {
      state.AddFeeDetails = action.payload;
    },
    updateDeleteFeeDtails: (state, action) => {
      state.DeleteFeeDetails = action.payload;
    },
    updateGetFeeDtails: (state, action) => {
      state.FeeDetails = action.payload;
    },
    updateGetResultsAsset: (state, action) => {
      state.ResultsAsset = action.payload;
    },
    updateEditAsset: (state, action) => {
      state.EditAsset = action.payload;
    },
    updateDeleteRoom: (state, action) => {
      state.DeleteRoom = action.payload;
    },
    updateEditFeeDetails: (state, action) => {
      state.EditFeeDetails = action.payload;
    },
    updateEditRoom: (state, action) => {
      state.EditRoom = action.payload;
    },
    updateAddMapSetup: (state, action) => {
      state.AddMap = action.payload;
    },
    updateGetMapSetup: (state, action) => {
      state.Map = action.payload;
    },
    updatePostImgMap: (state, action) => {
      state.ImgMap = action.payload;
    },
    updateGetImgMap: (state, action) => {
      state.ResultsMap = action.payload;
    },
    updateDeleteMap: (state, action) => {
      state.DeleteMap = action.payload;
    },
    updateEditMap: (state, action) => {
      state.EditMap = action.payload;
    },
    updateDeleteImgMap: (state, action) => {
      state.DeleteImgMap = action.payload;
    },
    updateDeleteAsset: (state, action) => {
      state.DeleteAsset = action.payload;
    },
    updateContractExpired: (state, action) => {
      state.ContractExpired = action.payload;
    },
    setLoadingAsset: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const { setLoadingAsset } = AssetSlice.actions;
export const { updateGetZone } = AssetSlice.actions;
export const getZonedetail = (value) => async (dispatch) => {
  await getZone(value).then(async (data) => {
    await dispatch(updateGetZone(data));
  });
};

export const { updateAddZone } = AssetSlice.actions;
export const AddZonedetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await AddZone(value);
    dispatch(updateAddZone(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateDeleteZone } = AssetSlice.actions;
export const DeleteZoneDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await DeleteZone(value);
    dispatch(updateDeleteZone(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateGetFloor } = AssetSlice.actions;
export const getFloordetail = (value) => async (dispatch) => {
  await getFloor(value).then(async (data) => {
    await dispatch(updateGetFloor(data));
  });
};

export const { updateAddFloor } = AssetSlice.actions;
export const AddFloordetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await AddFloor(value);
    dispatch(updateAddFloor(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateDeleteFloor } = AssetSlice.actions;
export const DeleteFloorDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await DeleteFloor(value);
    dispatch(updateDeleteFloor(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateAddAsset } = AssetSlice.actions;
export const AddAssetdetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await AddAsset(value);
    dispatch(updateAddAsset(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updategetAsset } = AssetSlice.actions;
export const getAssetdetail = (value) => async (dispatch) => {
  await getAsset(value).then(async (data) => {
    await dispatch(updategetAsset(data));
  });
};

export const { updateRoomAndProperty } = AssetSlice.actions;
export const RoomAndPropertydetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await RoomAndProperty(value);
    dispatch(updateRoomAndProperty(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateAddRoom } = AssetSlice.actions;
export const AddRoomdetail = (value) => async (dispatch) => {
  await AddRoom(value).then(async (data) => {
    await dispatch(updateAddRoom(data));
  });
};

export const { updategetFeeType } = AssetSlice.actions;
export const getFeeTypedetail = (value) => async (dispatch) => {
  await getFeeType(value).then(async (data) => {
    await dispatch(updategetFeeType(data));
  });
};

export const { updateAddRoomSize } = AssetSlice.actions;
export const AddRoomSizedetail = (value) => async (dispatch) => {
  await AddRoomSize(value).then(async (data) => {
    await dispatch(updateAddRoomSize(data));
  });
};

export const { updategetFacilities } = AssetSlice.actions;
export const getFacilitiesdetail = (value) => async (dispatch) => {
  await getFacilities(value).then(async (data) => {
    await dispatch(updategetFacilities(data));
  });
};

export const { updategetUnit } = AssetSlice.actions;
export const getUnitdetail = (value) => async (dispatch) => {
  await getUnit(value).then(async (data) => {
    await dispatch(updategetUnit(data));
  });
};

export const { updategetAssetType } = AssetSlice.actions;
export const getAssetTypedetail = (value) => async (dispatch) => {
  await getAssetType(value).then(async (data) => {
    await dispatch(updategetAssetType(data));
  });
};

export const { updategetRoomAndProperty } = AssetSlice.actions;
export const getRoomAndPropertydetail = (value) => async (dispatch) => {
  await getRoomAndProperty(value).then(async (data) => {
    await dispatch(updategetRoomAndProperty(data));
  });
};

export const { updategetAddFee } = AssetSlice.actions;
export const getAddFeedetail = (value) => async (dispatch) => {
  await getAddFee(value).then(async (data) => {
    await dispatch(updategetAddFee(data));
  });
};

export const { updategetNewAsset } = AssetSlice.actions;
export const getNewAssetdetail = (value) => async (dispatch) => {
  await getNewAsset(value).then(async (data) => {
    await dispatch(updategetNewAsset(data));
  });
};

export const { updateAddFeeDtails } = AssetSlice.actions;
export const postFeeDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await addFeeDtails(value);
    dispatch(updateAddFeeDtails(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateDeleteFeeDtails } = AssetSlice.actions;
export const deleteFeeDetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await deleteFeeDetails(value);
    dispatch(updateDeleteFeeDtails(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateGetFeeDtails } = AssetSlice.actions;
export const getFeeDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await getFeeDtails(value);

    await dispatch(updateGetFeeDtails(data));
    dispatch(setLoadingAsset(false));
  } catch (error) {
    dispatch(setLoadingAsset(false));
    console.error("Error in getUploadImageDetail:", error);
  }
};

export const { updateGetResultsAsset } = AssetSlice.actions;
export const getResultsAssetDetails = (value) => async (dispatch) => {
  await getResultsAsset(value).then(async (data) => {
    await dispatch(updateGetResultsAsset(data));
  });
};

export const { updateEditAsset } = AssetSlice.actions;
export const editAssetdetail = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await editAsset(value);
    dispatch(updateEditAsset(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateDeleteRoom } = AssetSlice.actions;
export const deleteRoomDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await deleteRoom(value);
    dispatch(updateDeleteRoom(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateEditFeeDetails } = AssetSlice.actions;
export const editFeeDetailss = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await editFeeDetails(value);
    dispatch(updateEditFeeDetails(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateEditRoom } = AssetSlice.actions;
export const editRoomDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await editRoom(value);

    dispatch(updateEditRoom(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateAddMapSetup } = AssetSlice.actions;
export const AddMapSetupDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await addMapSetup(value);
    dispatch(updateAddMapSetup(data));
    dispatch(setLoadingAsset(false));
    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateGetMapSetup } = AssetSlice.actions;
export const getMapDetails = (value) => async (dispatch) => {
  await getMapSetup(value).then(async (data) => {
    await dispatch(updateGetMapSetup(data));
  });
};

export const { updatePostImgMap } = AssetSlice.actions;
export const AddImgMapSetupDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await postImageMapSetup(value);
    dispatch(updatePostImgMap(data));
    dispatch(setLoadingAsset(false));

    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateGetImgMap } = AssetSlice.actions;
export const getImgMapDetails = (value) => async (dispatch) => {
  await getImageMapSetup(value).then(async (data) => {
    await dispatch(updateGetImgMap(data));
  });
};

export const { updateDeleteMap } = AssetSlice.actions;
export const DeleteMapSetupDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await deleteMapSetup(value);
    dispatch(updateDeleteMap(data));
    dispatch(setLoadingAsset(false));

    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateEditMap } = AssetSlice.actions;
export const editMapSetupDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await editMapSetup(value);
    dispatch(updateEditMap(data));
    dispatch(setLoadingAsset(false));

    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateDeleteImgMap } = AssetSlice.actions;
export const deleteImgMapDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await deleteImgMap(value);
    dispatch(updateDeleteImgMap(data));
    dispatch(setLoadingAsset(false));

    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateDeleteAsset } = AssetSlice.actions;
export const deleteAssetDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await deleteAsset(value);
    dispatch(updateDeleteAsset(data));
    dispatch(setLoadingAsset(false));

    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export const { updateContractExpired } = AssetSlice.actions;
export const editContractExpiredDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoadingAsset(true));
    const data = await editContractExpired(value);
    dispatch(updateContractExpired(data));
    dispatch(setLoadingAsset(false));

    return data;
  } catch (error) {
    console.error(error);
    dispatch(setLoadingAsset(false));
  }
};

export default AssetSlice.reducer;
